import { FirebaseProvider } from '../contexts/FirebaseContext';
import { useSurveyResults } from '../hooks/useSurveyResults';
import { useTranslation } from '../hooks/useTranslation';
import { APP_CONFIG } from '../config/settings';
import { formatDateWithYear } from '../utils/formatDate';
import Chart from './charts/Chart';
import './PrintResultsPage.css';

function PrintResultsContent() {
  const { stats, loading } = useSurveyResults();
  const { translations, t } = useTranslation();

  // English only for print
  const questionsEn = Object.keys(translations.questions.en);
  const answersEn = Object.values(translations.questions.en) as string[][];

  if (loading) {
    return (
      <div className="print-loading">
        <p>Loading results for printing...</p>
      </div>
    );
  }

  if (!stats || !stats.responsesByQuestion) {
    return (
      <div className="print-error">
        <p>No data available for printing</p>
      </div>
    );
  }

  // Calculate end date: today if before poll end date, otherwise poll end date
  const today = new Date();
  const pollEndDate = new Date(APP_CONFIG.END_DATE + 'T00:00:00');
  const endDate = today < pollEndDate ? today : pollEndDate;

  const formatPrintDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const startDateFormatted = formatDateWithYear(APP_CONFIG.START_DATE, 'en');

  return (
    <div className="print-results">
      <header className="print-header">
        <h1>Visitors Poll</h1>
        <h2>{t('institution', 'en')}</h2>
        <p>
          {stats.totalResponses} results - {startDateFormatted} -{' '}
          {formatPrintDate(endDate)}
        </p>
      </header>

      <div className="print-charts-grid">
        {questionsEn.map((questionText, index) => {
          const questionCount = stats.responsesByQuestion[index] || {};
          return (
            <div key={index} className="print-chart-container">
              <Chart
                questionNumber={index}
                questionText={questionText}
                answers={answersEn[index]}
                count={questionCount}
                totalRespondents={stats.totalResponses}
                variant="print"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

function PrintResultsPage() {
  return (
    <FirebaseProvider>
      <PrintResultsContent />
    </FirebaseProvider>
  );
}

export default PrintResultsPage;
